/**
 * Phase 18 Ask 4.2 — pure helper: heatmap resolution multiplier → grid
 * dimensions. Base grid is 16 × 12. Multiplier ∈ [1, 4] scales both
 * axes linearly. Kept in its own module so unit tests don't have to
 * import the full WorkbenchTerrainPane component (which pulls in
 * react-router and other render-time dependencies).
 */
export function resolveHeatmapGrid(multiplier) {
    const m = Math.max(1, Math.min(4, Number(multiplier) || 1));
    return { nx: 16 * m, ny: 12 * m, multiplier: m };
}
